import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ToastConfigService } from '@services';
import { Subscription } from 'rxjs';
import { HandleError } from '../../../core/models/handle-error';
import { AuthService } from '../../../core/services/auth/auth.service';
import { SpinnerService } from '../../../core/services/spinner/spinner.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { VideosService } from '../videos.service';

import { APP_SETTINGS } from '@services';
import { AnalyticsService } from '../../../core/services/analytics/analytics.service';
import { NgIf, NgClass, NgFor, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { ShareContentComponent } from '../../share-content/share-content.component';
import { SearchFilterPipe } from '../../../shared/pipes/search-filter.pipe';
import { HighlightSearchPipe } from '../../../shared/pipes/highlight-search.pipe';

@Component({
    selector: 'app-videos-home',
    templateUrl: './videos-home.component.html',
    styleUrls: ['./videos-home.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, FormsModule, NgClass, NgFor, RouterLink, NgxPaginationModule, ShareContentComponent, DatePipe, SearchFilterPipe, HighlightSearchPipe]
})
export class VideosHomeComponent implements OnInit, OnDestroy {

  public newVideos: any;
  public screenWidth: any;
  private subscription: Subscription[] = [];
  public shareContentObject = {};
  public serviceError = 'Loading data. Please wait...';
  public dateFormat: string;
  APP_SETTINGS : any;
  // public large_bmw_image = "assets/images/C100_200px_BMW_RGB72DPI.png";
  public large_bmw_width = "150px";
  public large_bmw_height = "150px";
  public videoThumbnail = APP_SETTINGS.isMINI === 'true' ? APP_SETTINGS.miniVideoThumbnail : APP_SETTINGS.isRollsRoyce === 'true' ? APP_SETTINGS.rollsRoyceVideoThumbnail : APP_SETTINGS.videoThumbnail;
  public videoThumbnailHeight = APP_SETTINGS.videoThumbnailHeight;
  public videoThumbnailWidth = APP_SETTINGS.videoThumbnailWidth;

  page: number = 1;
  isPaginateFlag = false;
  count: number = 0;
  pageSize: number = 30;

  @ViewChild('modalCloseButton')
  private modalCloseButtonEle: ElementRef;

  username: string;
  constructor(
    private utilityService: UtilityService,
    private spinnerService: SpinnerService,
    private videoService: VideosService,
    private authService: AuthService,
    private analyticsService: AnalyticsService,
    private toastService: ToastConfigService,
    private changeDetector: ChangeDetectorRef
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    // set image details here. hopefully improves performance
    this.subscription = [];
    this.username = this.authService.getUserName();
    this.APP_SETTINGS = APP_SETTINGS;
    APP_SETTINGS.currentPage = 'videos';
    this.dateFormat = 'yyyy-MM-dd';
    this.spinnerService.show('bmwSpinner');
    this.subscription.push(this.videoService.getVideosData().subscribe(value => {
      this.spinnerService.hide('bmwSpinner');
      this.newVideos = value;
      this.changeDetector.detectChanges();
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));

    this.subscription.push(this.utilityService.shareContentPopup$.subscribe(data => {
      if (typeof data === 'boolean') {
        this.modalCloseButtonEle.nativeElement.click();
      }

    }));
    /*
    this.subscription.push(this.utilityService.shareContentPopup$.subscribe(data => {
      if (typeof data === 'boolean') {
        this.modalCloseButtonEle.nativeElement.click();
      }
    }));*/
  }
  addVideoToWatchlist(videoId, videoDisplayNumber) {
    //Analytics call
    this.analyticsService.trackSavedContentByTypeLineMake('Videos', videoDisplayNumber, 'saved');
    //Analytics call
    this.videoService.addVideoToWatchlist(this.username, videoId).subscribe(data => {
      if (data) {
        this.toastService.popToast('Video added to watchlist');
      }
    });
  }
  shareContent(id, type, channel, videoDisplayNumber) {
    this.shareContentObject = {
      id: id,
      type: type,
      channel: channel,
      videoDisplayNumber: videoDisplayNumber
    };
  }
  ngOnDestroy(): void {
    this.subscription.map(s => s.unsubscribe());
  }

  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  pageNumChange(event) {
    this.page = event;
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
  }

  disablePagination() {
    this.isPaginateFlag = true;
  }
}
